var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "386.000000pt",
    height: "448.000000pt",
    viewBox: "0 0 386.000000 448.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,448.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1840 4474 c-106 -21 -222 -80 -305 -155 -68 -63 -146 -180 -177 -265 -22 -63 -23 -63 -91 -93 -171 -76 -364 -219 -470 -348 -114 -140 -201 -314 -246 -489 -39 -155 -52 -267 -61 -559 -19 -617 -65 -763 -340 -1105 -121 -150 -135 -180 -135 -295 0 -82 3 -97 33 -157 40 -81 110 -148 190 -180 l57 -23 1635 0 1635 0 57 23 c80 32 150 99 190 180 30 60 33 75 33 157 0 115 -14 145 -135 295 -113 141 -157 204 -202 295 -92 183 -138 451 -138 811 0 702 -233 1131 -748 1380 l-97 47 -24 60 c-37 95 -89 175 -160 247 -113 114 -234 169 -386 175 -49 2 -101 1 -115 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232 468 c-19 -19 -15 -36 31 -106 162 -249 467 -391 761 -354 235 30 447 160 573 354 46 70 50 87 31 106 -17 17 -1379 17 -1396 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIcon);
export default __webpack_public_path__ + "static/media/NewsIcon.6593d4339999a1c332825ae3e6e45865.svg";
export { ForwardRef as ReactComponent };